import { APPROVAL_TYPES, COMITEE_TYPES } from 'lib/api/approvals/types';
import { PaymentRequestPassive } from 'lib/types/models';
import Committee from 'pages/Finance/Components/Financing/common/Comittee';
import { ComiteeTabProvider } from 'pages/Finance/Components/Financing/common/Comittee/ComiteeTabProvider';
import React from 'react';

const PaymentRequestApprovals = ({
  request,
  refreshRequest,
}: {
  request: PaymentRequestPassive;
  refreshRequest: () => Promise<void>;
}) => {
  const comiteeTabInfo = {
    requestType: APPROVAL_TYPES.PAYMENT_REQUEST_PASSIVE,
    comiteeType: COMITEE_TYPES.RISK,
    requestId: request.id,
    comiteeId: request.comiteeId,
    canEdit: request.status === 'En revisión',
    isRejected: request.status === 'Rechazada',
    isActive: request.status === 'Completada' || request.status === 'En giro',
    refreshRequest: refreshRequest,
  };
  return (
    <ComiteeTabProvider info={comiteeTabInfo}>
      <Committee />;
    </ComiteeTabProvider>
  );
};

export default PaymentRequestApprovals;
